/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const TypeIcon = ({ width = 24, height = 24, hidden = false, title = 'Type' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M23.715 4.909h3.571A.721.721 0 0 0 28 4.182V2.727A.721.721 0 0 0 27.286 2h-3.817a2.831 2.831 0 0 0-2.02.852L18 6.364l-3.449-3.512A2.831 2.831 0 0 0 12.531 2H8.714A.721.721 0 0 0 8 2.727v1.455a.721.721 0 0 0 .714.727h3.572l3.791 4.364V22h-4.506a.721.721 0 0 0-.714.727v1.455a.721.721 0 0 0 .714.727h4.505v1.818l-3.791 4.364H8.714a.721.721 0 0 0-.714.727v1.455a.721.721 0 0 0 .714.727h3.817a2.831 2.831 0 0 0 2.02-.852L18 29.636l3.449 3.512a2.831 2.831 0 0 0 2.02.852h3.817a.721.721 0 0 0 .714-.727v-1.455a.721.721 0 0 0-.714-.727h-3.571l-3.792-4.364v-1.818h4.506a.721.721 0 0 0 .714-.727v-1.455a.721.721 0 0 0-.714-.727h-4.506V9.273Z"
    />
  </svg>`;
};
